const routes = {
    '/': 'Home',
    '/dashboard': 'Dashboard',
    '/components': 'Components',
    '/requests': 'Tractor Requests',
    '/farmers': 'Farmers',
    '/fbo': 'FBO',
    '/profile':'Account Profile',
    '/tractors': 'Tractors',
    '/maps': 'Maps',
    '/operators': 'Operators',
    '/tractor_owners': 'Tractor Owners',
    '/transactions': 'Transactions',
    '/users' : 'Users',
    '/account/tickets': 'Tickets',
    '/services/ussd': 'USSD',
    '/services/broadcast': 'Broadcast',
    '/management/settings': 'Settings',
    '/support/feedback': 'User Feedback',
    '/support/tickets': 'User Tickets Support',
    '/support/tickets_management': 'Ticket Management',
    '/finance/payout': 'Payouts',
    '/finance/credit/virtual/payments': [ 'Finance','Yolum', 'Payments' ],
    '/finance/credit/virtual/create/payment': ['Finance' , 'Yolum' , 'Create Yolum Payment' ],
    '/finance/credit/virtual/payment/detail/:id': ['Finance' , 'Yolum' , 'Yolum Payment Detail' ]
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js